// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// declare var require: any;
// const data = require('../../env.json');
// export const environment = {
//   production: false,
//   clientId: data.clientId,
//   clientSecret: data.clientSecret,
//   apiUrl: data.apiUrl,
//   baseUrl: data.baseUrl,
//   languageUrl: data.languageUrl,
//   paymentUrl: data.paymentUrl,
//   paymentApiKey: data.paymentApiKey
// };


export const environment = {
  production: true,
  "apiUrl": "https://adminbetaspace.empatydev.net/api/v1",
  "baseUrl": "https://betaspace.ltd",
  "clientId": "2",
  "clientSecret": "uo6s0m6tFycq7oli8vJm2sKEVB52XDbFScbyT1bF",
  "languageUrl": "https://adminbetaspace.empatydev.net//uploads/language",
  "paymentUrl": "https://static.mul-pay.jp/ext/js/token.js",
  "paymentApiKey": "9200000460892"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.



